import Router from "@/helpers/router";

import {
  WHATS_NEW_AUDIENCES,
  WHATS_NEW_ICONS,
  WhatsNewEntryI,
} from "@/modules/whats-new/lib/types";

const { CALLER, POD_LEAD, LGA, ADMIN } = WHATS_NEW_AUDIENCES;

const EVERYONE = [CALLER, POD_LEAD, LGA, ADMIN];

const TITLE = "Your Top 10 in Open pipeline";

/**
 * The Top 10 (C-16 S4, GLE-8411; coordinator decisions C16-D421, D430-D439).
 * It shows only while the backend's top_ten_enabled is on (see
 * useTopTenWhatsNewCards), for 48 hours from the switch-on day.
 *
 * Facts: backend #6857 (list type, 10 cap, guards, bells) and #6868 (read).
 */
export const TOP_TEN_2026_10_26: WhatsNewEntryI = {
  id: "2026-10-26-top-ten",
  // Switch-on day, 2026-10-26 12:00 ET, for 48 hours (coordinator, C-16-BUS §4).
  startsAt: "2026-10-26T16:00:00.000Z",
  endsAt: "2026-10-28T16:00:00.000Z",
  title: {
    [CALLER]: TITLE,
    [POD_LEAD]: TITLE,
    [LGA]: TITLE,
    [ADMIN]: TITLE,
  },
  sections: [
    {
      id: "top-ten",
      audiences: EVERYONE,
      icon: WHATS_NEW_ICONS.SPARKLES,
      title: "Top 10",
      items: [
        "Open pipeline's left column is now your Top 10: up to 10 nurtures you never want to lose. They stay until you remove them or book a meeting.",
        "Add one from a lead's page with “Add to Top 10” and pick when you'll call. You get a bell when it's due, and each morning a count of what's due today.",
        "Your other nurtures moved to Working lists → Nurture.",
      ],
      link: { label: "Open pipeline", href: Router.accounts() },
    },
  ],
};
